<template>
  <segment>
    <h3 class="ui dividing header">
      <i class="calendar alternate icon"/>
      <div class="content">
        {{ $t('patients.appointments.past') }}
      </div>
    </h3>
    <message :message="calendarMessage"/>
    <table class="ui collapsing celled unstackable center aligned table">
      <thead>
        <tr class="center aligned">
          <th>
            {{ $t('patients.appointments.time') }}
          </th>
          <th>
            {{ $t('patients.appointments.type') }}
          </th>
          <th>
            {{ $t('patients.appointments.status') }}
          </th>
          <th>
            {{ $tc('action', 2) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(appt, index) in appointments"
          :class="{ negative: appt.data.isCanceled }"
          :key="index">
          <td>
            {{ $d(appt.startTimestamp, 'full') }}
          </td>
          <td>
            <template v-if="appt.data.appointmentType === 'doctor'">
              {{ $t('patients.appointments.doctor') }}
            </template>
            <template v-if="appt.data.appointmentType === 'coach'">
              {{ $t('patients.appointments.coach') }}
            </template>
          </td>
          <td :class="{ negative: appt.data.isCanceled, positive: !appt.data.isCanceled }">
            <template v-if="appt.data.isCanceled">
              {{ $t('patients.appointments.canceled') }}
            </template>
            <template v-else>
              {{ $t('patients.appointments.scheduled') }}
            </template>
          </td>
          <td>
            <button
              v-if="appt.data.isCanceled"
              type="button"
              @click="removeAppointment(appt)"
              :disabled="isLoading"
              :class="{ loading: isLoading && appointmentToRemove === appt.id }"
              class="ui tiny red basic button">
              <i class="x icon"/>
              {{ $t('patients.appointments.removeAppointment') }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </segment>
</template>

<script>
import { APIError } from '../../helpers'
import Segment from '../utility/Segment'

export default {
  name: 'PatientAppointmentsPast',
  components: { Segment },
  props: {
    appointments: {
      type: Array,
      required: true
    },
    patient: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      appointmentToRemove: null,
      calendarMessage: {
        text: '',
        class: ''
      }
    }
  },
  methods: {
    editAppointment (appointment) {
      return new Promise(
        (resolve, reject) => {
          this.isLoading = true
          this.appointmentToRemove = appointment.id

          this.calendarMessage = {
            text: '',
            class: ''
          }

          let requestUrl = `${process.env.VUE_APP_PROGRAM_URL}/programUsers/${this.patient.userId}/removeUserEvents`
          let requestBody = {
            eventIds: [appointment.id]
          }

          this.$axios.put(
            requestUrl,
            requestBody,
            this.requestConfig
          ).then(
            () => {
              this.$emit('updated')
              this.calendarMessage = {
                class: 'success',
                text: this.$t('patients.appointments.removeSuccess')
              }
              resolve()
            },
            ({ response }) => {
              this.calendarMessage = {
                text: this.$t('errors.unexpected'),
                class: 'error'
              }
              reject(new APIError('Error removing appointment', response))
            }
          ).then(
            () => {
              this.isLoading = false
              this.appointmentToRemove = null
            }
          )
        }
      )
    },
    removeAppointment (appointment) {
      if (confirm(this.$t('patients.appointments.cancelConfirmation'))) {
        let reminder = appointment.data.hasReminder

        let removedAppointment = Object.assign({}, appointment)

        removedAppointment.data.isCanceled = true
        removedAppointment.data.hasReminder = false

        this.editAppointment(removedAppointment)
          .catch(
            error => {
              this.$rollbar.error(error.message, error.response)
            }
          )
          // .then(
          //   () => {
          //     if (reminder) {
          //       // TODO: Remove timestamps from relevant in `userEvent.data.reminders`
          //     }
          //   }
          // ).catch(
          //   error => {
          //     this.$rollbar.error(error.message, error.response)
          //   }
          // )
      }
    }
  }
}
</script>

<style scoped>

</style>
